<template>
  <div class="jlist">
    <div v-if="showTabs" class="jlist__tabs">
      <SortTabs v-model="orderBy" :options="tabOptions" />
    </div>

    <transition-group name="pop" tag="div" class="jlist__items">
      <JokeCard
        v-for="joke in jokes"
        :key="joke.id"
        :joke="joke"
      />
    </transition-group>

    <div v-if="loading" class="jlist__state">
      <span class="loader">🍌</span> On épluche…
    </div>
    <div v-else-if="!jokes.length" class="jlist__state">
      Aucune blague ici pour le moment.
    </div>
    <div v-if="!loading && jokes.length && !done" class="jlist__more">
      <BananaButton
        variant="outline"
        size="lg"
        :loading="loadingMore"
        @click="loadMore"
      >
        Voir plus de blagues
      </BananaButton>
    </div>

    <div v-else-if="!loading && jokes.length && done" class="jlist__end">
      🍌 Tu as tout lu. Bravo, tu es officiellement banané.
    </div>
  </div>
</template>

<script>
import JokeCard from './JokeCard.vue'
import SortTabs from './SortTabs.vue'
import BananaButton from '@/components/ui/BananaButton.vue'
import { JOKES_QUERY } from '@/graphql/jokes'

export default {
  name: 'JokesList',
  components: { JokeCard, SortTabs, BananaButton },
  props: {
    category: { type: String, default: null },
    showTabs: { type: Boolean, default: false },
    initialOrder: { type: String, default: 'RECENT' },
    pageSize: { type: Number, default: 20 },
  },
  data() {
    return {
      jokes: [],
      loading: true,
      loadingMore: false,
      done: false,
      orderBy: this.initialOrder,
      tabOptions: [
        { value: 'RECENT', label: 'Récent', emoji: '🕓' },
        { value: 'TOP', label: 'Top', emoji: '🏆' },
        { value: 'FLOP', label: 'Flop', emoji: '💩' },
        { value: 'TOP_LEGACY', label: 'Légendes', emoji: '👑' },
      ],
    }
  },
  mounted() {
    this.reload()
  },
  methods: {
    queryVars(offset) {
      return { category: this.category, count: this.pageSize, offset, orderBy: this.orderBy }
    },
    reload() {
      this.loading = true
      this.done = false
      this.$apollo.query({
        query: JOKES_QUERY,
        fetchPolicy: 'network-only',
        variables: this.queryVars(0),
      }).then(res => {
        this.jokes = res.data?.jokes ? [...res.data.jokes] : []
        this.done = this.jokes.length < this.pageSize
        this.loading = false
      }).catch(err => {
        console.error('Error loading jokes:', err)
        this.jokes = []
        this.loading = false
      })
    },
    loadMore() {
      if (this.loading || this.loadingMore || this.done) return
      this.loadingMore = true
      this.$apollo.query({
        query: JOKES_QUERY,
        fetchPolicy: 'network-only',
        variables: this.queryVars(this.jokes.length),
      }).then(res => {
        const batch = res.data?.jokes || []
        if (batch.length) this.jokes.push(...batch)
        if (batch.length < this.pageSize) this.done = true
        this.loadingMore = false
      }).catch(err => {
        console.error('Error loading more:', err)
        this.done = true
        this.loadingMore = false
      })
    },
  },
  watch: {
    category() { this.reload() },
    orderBy() { this.reload() },
  },
}
</script>

<style scoped>
.jlist { display: flex; flex-direction: column; }
.jlist__tabs { display: flex; justify-content: center; margin-bottom: 26px; }
.jlist__items { display: flex; flex-direction: column; gap: 20px; }
.jlist__state, .jlist__end {
  text-align: center;
  padding: 34px 20px;
  color: var(--text-soft);
  font-family: var(--font-accent);
  font-style: italic;
  font-size: 1.05rem;
}
.jlist__end { color: var(--banana-700); font-weight: 600; }
.loader { display: inline-block; animation: spin 1s linear infinite; }
@keyframes spin { to { transform: rotate(360deg); } }
.jlist__more { display: flex; justify-content: center; padding: 30px 20px 8px; }

/* card enter animation */
.pop-enter-active { transition: all 0.4s var(--ease-out); }
.pop-enter-from { opacity: 0; transform: translateY(20px) scale(0.98); }

@media (max-width: 560px) {
  /* let the sort tabs use the full width so they can scroll horizontally */
  .jlist__tabs { justify-content: stretch; }
  .jlist__tabs > * { width: 100%; }
  .jlist__items { gap: 16px; }
}
</style>
